export default __webpack_public_path__ + "static/media/background-5.5c8b01c5.jpg";